<div class="input-number-wrapper" [class.fluid]="fluid()">
  <label *ngIf="label()" [for]="id()" class="input-label">{{ label() }}</label>
  <p-inputnumber
    [inputId]="id()"
    [ngModel]="value()"
    (ngModelChange)="value.set($event)"
    [placeholder]="placeholder()"
    [disabled]="disabled()"
    [readonly]="readonly()"
    [min]="min()!"
    [max]="max()!"
    [step]="step()"
    [showButtons]="showButtons()"
    [buttonLayout]="buttonLayout()"
    [prefix]="prefix()"
    [suffix]="suffix()"
    [currency]="currency() || undefined"
    [mode]="mode()"
    [locale]="locale() || undefined"
    [minFractionDigits]="minFractionDigits()!"
    [maxFractionDigits]="maxFractionDigits()!"
    [useGrouping]="useGrouping()"
    [styleClass]="styleClass()"
    [fluid]="fluid()"
    (onInput)="handleChange($event)"
    (onBlur)="handleBlur($event)"
    (onFocus)="handleFocus($event)">
  </p-inputnumber>
</div>
